import { useMemo } from "react";
import { Adapt, Select, Sheet } from "tamagui";
import { FaChevronDown } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { zIndexes } from "@utils/zIndexLevel";

type SelectItemProps = {
  data: {
    id: string;
    placeholder?: string;
    options?: { label: string; value: string | number | boolean }[];
  };
  value: string;
  hasError?: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
};

const SelectItem = ({ data, value, disabled, hasError, onChange }: SelectItemProps) => {
  const currentLabel = useMemo(() => {
    return data.options?.find((opt) => opt.value.toString() === value)?.label;
  }, [value, data.options]);

  return (
    <Select id={data.id} value={value} onValueChange={onChange} disablePreventBodyScroll>
      <Select.Trigger
        disabled={!!disabled}
        opacity={!!disabled ? 0.5 : 1}
        iconAfter={<FaChevronDown size={10} />}
        borderColor={hasError ? "$red10" : "$borderColor"}>
        <Select.Value>{currentLabel || data?.placeholder || "請選擇"}</Select.Value>
      </Select.Trigger>

      <Adapt when="sm" platform="touch">
        <Sheet modal dismissOnSnapToBottom={false} dismissOnOverlayPress={false} zIndex={zIndexes.dropdownAboveSheet}>
          <Sheet.Frame>
            <Sheet.ScrollView>
              <Adapt.Contents />
            </Sheet.ScrollView>
          </Sheet.Frame>
          <Sheet.Overlay enterStyle={{ opacity: 0 }} exitStyle={{ opacity: 0 }} />
        </Sheet>
      </Adapt>

      <Select.Content zIndex={zIndexes.dropdownAboveSheet}>
        <Select.ScrollUpButton />
        <Select.Viewport minWidth={200}>
          <Select.Group>
            {data?.options &&
              data?.options.map((option, i) => (
                <Select.Item key={option.value.toString()} index={i} value={option.value.toString()}>
                  <Select.ItemText>{option.label}</Select.ItemText>
                  <Select.ItemIndicator marginLeft="auto">
                    <FaCheck size={14} />
                  </Select.ItemIndicator>
                </Select.Item>
              ))}
          </Select.Group>
        </Select.Viewport>
        <Select.ScrollDownButton />
      </Select.Content>
    </Select>
  );
};

export default SelectItem;
